// extracted by mini-css-extract-plugin
export default {"container":"SummaryTestPage_container__3OLu+","section":"SummaryTestPage_section__8EA+3","rightPanel":"SummaryTestPage_rightPanel__rdsdL","content":"SummaryTestPage_content__QN9tb"};